module.exports = __webpack_public_path__ + "static/ConfigJS-02ee25c0cb1eaf6f3d0525e97b5f6ea1.png";